import { Component, ojs, app, state, v, payload } from "modular-openscriptjs";
import { dom, tool } from "../../../fotastart";
import {
    pageInfo,
    scrollToTop,
    inform,
    isMobile,
    redirect,
} from "../../../helpers";
import { PAGES, api, routes, STRINGS, gc } from "../../../declarations";
import SearchResultProductView from "../../Views/SearchResultProductView";
import InfiniteScroll from "../../Blocks/InfiniteScroll";
import Spinner from "../../Blocks/Spinner";
import QuickOrderCard from "../Search/QuickOrderCard";

const h = app("h");
const broker = app("broker");

export default class BusinessProductsDefault extends Component {
    businessId = null;
    subcategoryId = null;
    companyState = state(null);
    subcategoryState = state(null);
    loading = state(true);
    page = 1;
    lastPage = false;

    async init() {
        this.loading.value = true;
        this.page = 1;
        this.lastPage = false;

        let params = app("router").params || {};
        this.businessId = params.businessId;
        this.subcategoryId = params.subcategoryId;

        try {
            // Fetch the business profile
            let res = await api.get(`/companies/${this.businessId}`);
            if (res && res.data && res.data.company) {
                this.companyState.value = res.data.company;
            }
        } catch (error) {
            console.error(error);
            inform("Failed to load business profile.", STRINGS.ERROR);
        } finally {
            this.loading.value = false;
        }
    }

    async getProducts(marker) {
        if (this.lastPage) {
            return;
        }

        const holder = dom.get("[hook='business-products-list']");

        const spinner = h.Spinner({
            class: "p-3",
            parent: marker,
            resetParent: true,
        });

        try {
            let res = await api.get(
                `/companies/${this.businessId}/subcategories/${this.subcategoryId}/products`,
                {
                    page: this.page,
                    interval: 10,
                },
                { silent: true },
            );

            if (!res) {
                spinner.remove();
                return;
            }

            const products = res.data.products.data || [];

            if (products.length === 0 && this.page === 1) {
                h.div(
                    {
                        class: "bg-white p-5 rounded-4 border text-center shadow-sm w-100 mt-4",
                        parent: holder,
                        resetParent: true,
                    },
                    h.div(
                        {
                            class: "rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3 bg-light",
                            style: "width: 80px; height: 80px;",
                        },
                        h.i({
                            class: "bi bi-box-seam text-secondary fs-1",
                        }),
                    ),
                    h.h5({ class: "fw-bold text-dark" }, "No products found"),
                    h.p(
                        { class: "text-muted mb-0" },
                        "There are no products in this category.",
                    ),
                );
                this.lastPage = true;
                return;
            }

            if (this.page === 1 && products.length > 0 && products[0].categories) {
                let subcat = products[0].categories.find(
                    (c) => c.id == this.subcategoryId,
                );
                if (subcat) {
                    this.subcategoryState.value = subcat;
                    pageInfo(
                        subcat.name +
                            " Products - " +
                            (this.companyState.value?.name || "Business"),
                    );
                }
            }

            for (let product of products) {
                let id = `p-${product?.id}`;
                let rendered = false;

                if (dom.get(`[feed-product-id="${id}"]`, holder)) {
                    rendered = true;
                }

                if (!rendered) {
                    h.SearchResultProductView(product, {
                        class: "flex-shrink-0 h-100",
                        style: isMobile() ? "width: 150px;" : "width: 280px;",
                        parent: holder,
                        $feed_product_id: id,
                        listeners: {
                            click: () => {
                                broker.send(
                                    app("$e").product.needs.display,
                                    payload({ product }),
                                );
                            },
                        },
                    });
                }
            }

            let currentPage = res.data.products.current_page;
            let lastPageNum = res.data.products.last_page;

            if (currentPage >= lastPageNum || products.length === 0) {
                let name = this.companyState.value?.handle ? this.companyState.value?.name + ` (@${this.companyState.value?.handle})` : (this.companyState.value?.name || "[Business Name]");

                h.div(h.QuickOrderCard(`Bought from ${name}: `), {
                    parent: holder,
                    class: "w-100 mt-4",
                });
                this.lastPage = true;
            } else {
                this.page = currentPage + 1;
            }
        } catch (e) {
            console.error(e);
        } finally {
            spinner.remove();
        }
    }

    render() {
        scrollToTop();
        let params = app("router").params || {};
        if (
            this.businessId !== params.businessId ||
            this.subcategoryId !== params.subcategoryId
        ) {
            this.businessId = params.businessId;
            this.subcategoryId = params.subcategoryId;
            this.init();
        }

        return h.div(
            { class: "bg-light pb-5 py-md-5", style: "min-height: 100vh;" },
            v(this.loading, (loadingState) => {
                let isLoading = loadingState.value;
                if (isLoading) {
                    return h.div(
                        {
                            class: "d-flex justify-content-center align-items-center w-100",
                            style: "height: 60vh;",
                        },
                        h.div({
                            class: "spinner-border text-primary",
                            role: "status",
                        }),
                    );
                }

                return v(this.companyState, (compState) => {
                    let company = compState.value;
                    if (!company) {
                        return h.div(
                            { class: "container px-4 py-5 text-center" },
                            h.h3(
                                { class: "fw-bold text-dark" },
                                "Business Not Found",
                            ),
                            h.span(
                                {
                                    class: "btn btn-primary mt-3",
                                    listeners: {
                                        click: () => {
                                            redirect("/businesses");
                                        },
                                    },
                                },
                                "Back to Businesses",
                            ),
                        );
                    }

                    return v(this.subcategoryState, (subcatState) => {
                        let subcategory = subcatState.value;
                        let subcatName = subcategory
                            ? subcategory.name
                            : "Products";

                        return h.div(
                            // Header
                            h.div(
                                {
                                    class: "bg-white border-bottom py-4 mb-3 shadow-sm sticky-top",
                                    style: "z-index: 1020; top: 56px;",
                                },
                                h.div(
                                    {
                                        class: "container px-4 d-flex align-items-center gap-3",
                                    },
                                    h.span(
                                        {
                                            class: "btn btn-light rounded-circle d-flex align-items-center justify-content-center",
                                            style: "width: 40px; height: 40px;",
                                            listeners: {
                                                click: () => {
                                                    redirect(
                                                        `/business/${company.id}`,
                                                    );
                                                },
                                            },
                                        },
                                        h.i({ class: "bi bi-arrow-left fs-5" }),
                                    ),
                                    h.div(
                                        h.h4(
                                            {
                                                class: "fw-bold mb-1 text-dark m-0",
                                                style: "font-size: 1.25rem;",
                                            },
                                            subcatName,
                                        ),
                                        h.div(
                                            {
                                                class: "d-flex align-items-center gap-2 mt-1",
                                            },
                                            company.logo_path
                                                ? h.img({
                                                      src: company.logo_path,
                                                      class: "rounded-circle flex-shrink-0",
                                                      style: "width: 24px; height: 24px; object-fit: cover;",
                                                  })
                                                : h.div(
                                                      {
                                                          class: "rounded-circle flex-shrink-0 bg-primary text-white d-flex align-items-center justify-content-center fw-bold",
                                                          style: "width: 24px; height: 24px; font-size: 0.75rem;",
                                                      },
                                                      company.name
                                                          ? company.name
                                                                .charAt(0)
                                                                .toUpperCase()
                                                          : "?",
                                                  ),
                                            h.span(
                                                { class: "d-flex flex-wrap gap-2" },
                                                h.span(
                                                    {
                                                        class: "text-dark fw-semibold small",
                                                    },
                                                    company.name,
                                                ),
                                                h.span(
                                                    {
                                                        class: "text-muted small",
                                                    },
                                                    "@",
                                                    company.handle,
                                                ),
                                            ),
                                        ),
                                    ),
                                ),
                            ),

                            // Products Grid
                            h.div(
                                { class: "container" },
                                h.InfiniteScroll({
                                    child: h.div({
                                        class: "d-flex gap-3 gap-md-4 flex-wrap justify-content-around justify-content-md-start",
                                        hook: "business-products-list",
                                    }),
                                    callback: (entries, observer, marker) => {
                                        if (
                                            entries[0]?.isIntersecting &&
                                            !this.lastPage
                                        ) {
                                            this.getProducts(marker);
                                        }
                                    },
                                }),
                            ),
                        );
                    });
                });
            }),
        );
    }
}

ojs(
    BusinessProductsDefault,
    SearchResultProductView,
    InfiniteScroll,
    Spinner,
    QuickOrderCard,
);
